import { render, staticRenderFns } from "./PendingExternalProducts.vue?vue&type=template&id=0c1065c9"
import script from "./PendingExternalProducts.vue?vue&type=script&lang=js"
export * from "./PendingExternalProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports